import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import ChoixText from "../../global/ChoixText";
import SauvegardeManager from "../../SauvegardeManager";
import Article from "./Article";
import DOMArticle from "./DOMArticle";

export default class Ordi extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        
        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        // Gestion de la progression
        this.sauvegardeManager = new SauvegardeManager()
        this.progression = this.sauvegardeManager.getChapitreProgression("Chapitre2")["ordi"];
        this.config = this.scene.cache.json.get('config')['Chapitre2']['ordi']

        // Ajout fond ordi
        this.background = this.scene.add.image(0, 0, 'ordi_background').setOrigin(0.5, 0);
        this.background.setInteractive();
        this.add(this.background);

        // Ajout article linkedin
        // Ajout du fond
        let article_background = this.scene.add.image(-this.background.width/2 + 510, 80, 'article_background').setOrigin(0, 0);
        this.add(article_background);

        let faux_article = this.scene.add.image(article_background.x + 23, article_background.y + 66, 'faux_article').setOrigin(0, 0);
        this.add(faux_article);

        this.article = new DOMArticle(this.scene, article_background.x + 34, article_background.y + 65)
        // this.article = new Article(this.scene, -this.background.width/2 + 510, 80)
        this.add(this.article);

        // Ajout liens externes (google, wikipedia, etc)
        this.icons = []
        this.addIcons()

        this.setSize(this.background.width, this.background.height);

        // Ajout code si ordi locked
        if(this.progression.locked){
            this.lockButtons();
            this.setLocked()
            this.article.setActive(false).setVisible(false);
        }
    }

    animIn(endFunc){
        let audio = 'OrdiLocked'
        if(!this.progression.locked){
            audio = 'OrdiUnlocked'
        }
        this.soundManager.playOnce(audio)
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: this.scene.height - this.height,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    animOut(endFunc){
        this.soundManager.playOnce('OrdiClosed')
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: this.y + 200,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    // Block
    lockButtons(){
        this.icons.forEach( button => {
            button.disableInteractive();
        })
    }

    unlockButtons(){
        this.icons.forEach( button => {
            button.setInteractive({useHandCursor: true});
        })
    }

    isLocked() {
        return this.progression.locked;
    }

    setLocked(){
        this.lockedContainer = this.scene.add.container(0, 0, [])
        this.add(this.lockedContainer);

        // Modif du fond
        this.backgroundLocked = this.scene.add.image(0, 0, 'ordi_code').setOrigin(0.5, 0);
        this.backgroundLocked.setInteractive();
        this.lockedContainer.add(this.backgroundLocked);

        // Ajout du code à rentrer
        const titre = this.scene.add.text(0, 108, "Vous avez oublié votre mot de passe !", {
            fontSize: '36px',
            fontFamily: FONTS.Inter28ExtraBold,
            color: Colors.Text.White
        }).setOrigin(0.5, 0);
        this.lockedContainer.add(titre);

        const sousTitre = this.scene.add.text(0, titre.y + titre.height, "Pour accéder à cette session, vous devez répondre correctement\naux trois questions secrètes associées à ce compte.", {
            fontSize: '22px',
            fontFamily: FONTS.Inter28MediumItalic,
            color: Colors.Text.White,
        }).setOrigin(0.5, 0);
        this.lockedContainer.add(sousTitre);

        const q1 = this.scene.add.text(0, sousTitre.y + sousTitre.height + 70, "Quel est le nom des habitants de Rio de Janeiro ?", {
            fontSize: '28px',
            fontFamily: FONTS.Inter28MediumItalic,
            color: Colors.Text.White,
        }).setOrigin(0.5, 0);
        this.lockedContainer.add(q1);

        this.rep1 = new ChoixText(this.scene, 0, q1.y + 84, this.config.code.chiffre1, () => {this.checkCode()})
        this.lockedContainer.add(this.rep1);

        const q2 = this.scene.add.text(0, q1.y + q1.height + 130, "Quelle montagne de Rio est visible de la fenêtre de mon bureau ? ", {
            fontSize: '28px',
            fontFamily: FONTS.Inter28MediumItalic,
            color: Colors.Text.White,
        }).setOrigin(0.5, 0);
        this.lockedContainer.add(q2);

        this.rep2 = new ChoixText(this.scene, 0, q2.y + 84, this.config.code.chiffre2, () => {this.checkCode()})
        this.lockedContainer.add(this.rep2);

        const q3 = this.scene.add.text(0, q2.y + q2.height + 130, "Quel est mon animal de compagnie ?", {
            fontSize: '28px',
            fontFamily: FONTS.Inter28MediumItalic,
            color: Colors.Text.White,
        }).setOrigin(0.5, 0);
        this.lockedContainer.add(q3);

        this.rep3 = new ChoixText(this.scene, 0, q3.y + 84, this.config.code.chiffre3, () => {this.checkCode()})
        this.lockedContainer.add(this.rep3);
    }

    // -- Code à rentrer
    checkCode(){
        if(
            this.rep1.isTrue() &&
            this.rep2.isTrue() &&
            this.rep3.isTrue()
        ){
            this.scene.closePopupOrdi();
            this.rep1.hideButtons();
            this.rep2.hideButtons();
            this.rep3.hideButtons();
            this.setUnlocked();
        }
    }

    setUnlocked(){
        // Update progression
        this.progression.locked = false;
        this.soundManager.playOnce('OrdiUnlocked')

        // Anim out
        this.scene.tweens.add({
            targets: this.lockedContainer,
            alpha: 0,
            duration: 500,
            onComplete: () => {
                this.lockedContainer.destroy(true);
                this.lockedContainer = null;

                this.scene.popupStart()
            }
        });

    }

    // Ajout liens externes sur le bureau de l'ordi
    addIcons(){
        const deltaY = 130

        Object.keys(this.config.liens).forEach( (icon, index) => {
            let iconElmt = this.scene.add.image(760, 180 + index * deltaY, icon).setOrigin(0.5);
            this.add(iconElmt)
            this.icons.push(iconElmt);

            iconElmt.setInteractive({useHandCursor: true})
            iconElmt.on('pointerup', () => {
                this.scene.tweens.add({
                    targets: iconElmt,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        window.open(this.config.liens[icon], '_blank');
                    }
                })
            })
        })
    }

    hideArticle(){
        if(this.article)
            this.scene.tweens.add({
                targets: this.article,
                alpha: 0,
                duration: 100,
                onComplete: () => {
                    this.article.setActive(false).setVisible(false);
                }
            });
    }

    showArticle(){
        if(this.article){
            this.article.setActive(true).setVisible(true);
            this.scene.tweens.add({
                targets: this.article,
                alpha: 1,
                duration: 300,
                onComplete: () => {
                }
            });
        }
    }
}